const _objectMapping = ((key, val) => {
  switch(key) {
    case 'trialEndsAt':
      return ['trial_ends_at', new Date(val)]
    default:
      return [key, val]
  }
})

export const identify = ((userId, traits) => {
  const _traits = {}
  Object.keys(traits).forEach(k => {
    let [key, val] = _objectMapping(k, traits[k])
    _traits[key] = val
  })
  if (_traits.hijacked) {
    window.analytics.user().traits({})
    delete _traits.hijacked
  }
  window.analytics.identify(userId, _traits)
})



/** WEBPACK FOOTER **
 ** ./src/utils/segment.js
 **/